module.exports = __webpack_public_path__ + "img/horizontal_3_7_r_pp13_8011.62ab86e7.png";